// Event tag vocabulary, mirrored from the Ruby side. Both read the same
// config/event_tags.json (see EventTags) so the list can't
// drift — splitting it across Ruby and TypeScript is how invalid tokens leaked.
import eventTags from '@config/event_tags.json';

export interface HolidayTag {
  id: string;
  /** Inclusive YYYY-MM-DD window during which the checkbox is offered. */
  startDate: string;
  endDate: string;
}

/** Permanent occasion tags, offered year-round. */
export const PERMANENT_EVENT_TAGS: readonly string[] = eventTags.permanent;

/** Festive occasion tags with the window their checkbox is offered in. */
export const HOLIDAY_TAGS: readonly HolidayTag[] = eventTags.holiday;

// Papercut operational flags. Accepted and round-tripped when already on an
// event, but never offered, never selectable, and never drawn as a chip.
export const INTERNAL_EVENT_TAGS: readonly string[] = eventTags.internal;

/** The only tokens a grain-core write may add (occasion + holiday). */
export const PUBLIC_EVENT_TAGS: readonly string[] = [
  ...PERMANENT_EVENT_TAGS,
  ...HOLIDAY_TAGS.map((h) => h.id),
];

// Named tokens kept for the behavioral call sites that reference them directly.
export const WEDDING_TAG = 'weddingEvent';
export const WEDDING_FOOD_TASTING_TAG = 'weddingFoodTasting';
export const B2B_FOOD_TASTING_TAG = 'b2bFoodTasting';

/**
 * Drop internal tokens so read surfaces (event detail, events list, the edit
 * chips) never draw a raw, label-less operational flag. Order preserved.
 */
export function drawableEventTags(tags: readonly string[]): string[] {
  return tags.filter((tag) => !INTERNAL_EVENT_TAGS.includes(tag));
}
